import React from "react";
import { Link } from "react-router-dom";
import { ROUTE_BASE_URL } from "../../api/common";
import { useUser } from "../AdminUsers/UserContext";
import logo from '../../assets/images/logo.png';
export default function MenuHeader(){
    const {websiteName, websiteLogo} = useUser();
    return(
    <div className="navbar-brand">
        <Link to={`${ROUTE_BASE_URL}/`}>
           {websiteLogo&&<img src={websiteLogo} width={90} alt="Amasi" className="img-fluid logo" />}
           {/* {<img src={logo} width={90} alt="Amasi" className="img-fluid logo" />} */}
           {websiteName&&<span>{websiteName}</span>}
        </Link>
        {/* <button
            type="button"
            className="btn-toggle-offcanvas btn btn-sm float-right"
            onClick={() => this.props.setOffcanvas(!this.props.offcanvas)}
        >
            <i className="lnr lnr-menu icon-close"></i>
        </button> */}
    </div>    
    );
}